<script>
import { getClientType } from '@utils/client'
import TelPopup from '@components/common/tel-popup.vue'
import Clipboard from 'clipboard'
import jsbarcode from 'jsbarcode'
import QRCode from 'qrcode'

export default {
  components: {TelPopup},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    barcode: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      qrImage:'',
      qrImageBig:'',
      expandShrink:true,
      year: '',
      month: '',
      date: '',
      hour: '',
      minutes: '',
      seconds: '',
      app_img_upload_url: `${process.env.VUE_APP_JAFAPP_HOST}`,
      img_upload_url: `${process.env.VUE_APP_JAFAPP_HOST}`,
      clipBoard: null,
      clipBoard_id: null,
      clipBoard_pw: null,
      show_clipboard: false,
      show_clipboard_id: false,
      show_clipboard_pw: false,
      paramArr: null,
      whiteListUrl: /^https:\/{2}(jafnavi.jp|www.jaf.or.jp|area.jaf.or.jp)\//,
      hasBlackListUrl: false,
    }
  },
  computed: {
    clientType() {
      return getClientType()
    },
    // 現在時刻
    now(){
        const currentTime = this.hour + ':' + this.minutes + ':' + this.seconds;
        return currentTime;
    },
    // 現在日付
    now_date(){
        const currentDate = this.year + '年' + this.month + '月' + this.date + '日';
        return currentDate;
    }
  },
  watch: {
    async barcode(val) {
      this.$nextTick(() => {
        if(val && val.CODE_FORMAT ==='3' && val.CODE) {
          if (this.clientType != 2) {
            jsbarcode('#barcode', val.CODE,{
              width:1,
              height:70,
              displayValue: true
            });
            jsbarcode('#barcodeBig', val.CODE,{
              width:2.2,
              height:110,
              displayValue: true
            });
          }
          else {
            jsbarcode('#barcode', val.CODE,{
              width:2,
              height:110,
              displayValue: true
            });
            jsbarcode('#barcodeBig', val.CODE,{
              width:2.5,
              height:140,
              displayValue: true
            });
          }
        }
      })
      if(val && (val.CODE_FORMAT === '2') && val.CODE) {
        var opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 0.3,
          margin: 1,
          width: 150,
        }
        var bigOpts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          quality: 0.3,
          margin: 1,
          width: 250,
        }
        this.qrImage = await QRCode.toDataURL(val.CODE, opts)
        this.qrImageBig = await QRCode.toDataURL(val.CODE, bigOpts)

      }
      this.hasBlackListUrl = false
      if(val && val.LINK_URL) {
        const decodeURI = decodeURIComponent(val.LINK_URL)
        if (!this.whiteListUrl.test(decodeURI)) {
          this.hasBlackListUrl = true
        }
      }
    },
  },
  created() {
    // 日付と時刻処理
    const that = this;
    setInterval(function(){
        const date = new Date();
        // 日付
        that.year  = date.getFullYear();
        that.month = date.getMonth() + 1;
        that.date  = date.getDate();
        // 時刻
        that.hour    = date.getHours().toString().padStart(2, '0');
        that.minutes = date.getMinutes().toString().padStart(2, '0');
        that.seconds = date.getSeconds().toString().padStart(2, '0');
    },1)
  },
  mounted() {
    // コード形式「IDとパスワード」の追加に伴い、クリップボードにコピー機能を追加（広域ページ移行STEP2）
    this.clipBoard = new Clipboard('.clipcopy');
    this.clipBoard_id = new Clipboard('.clipcopy_id');
    this.clipBoard_pw = new Clipboard('.clipcopy_pw');
    this.clipBoard.on('success', function(e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      $(".clipcopy_message").css("display", "block");

      e.clearSelection();
    });
    this.clipBoard_id.on('success', function(e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      $(".clipcopy_message_id").css("display", "block");

      e.clearSelection();
    });
    this.clipBoard_pw.on('success', function(e) {
      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);
      $(".clipcopy_message_pw").css("display", "block");

      e.clearSelection();
    });
    this.clipBoard.on('error', function(e) {
      console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
    this.clipBoard_id.on('error', function(e) {
      console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
    this.clipBoard_pw.on('error', function(e) {
      console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
    // -- クリップボード設定ここまで



  },
  methods: {
    expandCode(){
      this.expandShrink = !this.expandShrink
    },
    toUrl(url) {
      if (url !== '') {
        var postUrl = window.location.origin;
        if(this.barcode.POST_NO && this.barcode.POST_NO >= "1") {
          postUrl = postUrl + "/redirect" +
          "?sessionId=" + this.barcode.SsnId +
          "&url=" + url +
          "&postNo=" + this.barcode.POST_NO;
          if(this.barcode.C_CODE) {
            postUrl = postUrl +
            "&checkCode=" + this.barcode.C_CODE;
          }
          window.open(postUrl, '_blank');

        }else{
          window.open(url, '_blank');
        }
      }
    },

    cancelHandler() {
      this.expandShrink = true;
      this.$emit('cancel');
    },
  },
}
</script>

<template>
  <div id="modals">
    <transition class="modal">
      <div
        v-if="show === true"
        id="modal_back_cover"
        @click.self="cancelHandler"
      >
        <div :class="$style.modal_set" style="overflow :auto">
          <button :class="$style.cancel_btn" @click="cancelHandler"><span aria-hidden="true"><img src="@img/icon_72_close.png"></span></button>
          <div :class="$style.modal_contents">
            <div :class="$style.modal_inner">
              <div :class="$style.subject">
                現在時刻：{{ now }}
              </div>
              <div :class="$style.content">
                <p>
                  ※JAF会員以外はご利用いただけません。<br/>
                  画面表示日：{{ now_date }}
                </p>
                <!-- コード形式（0:バーコードなし、1:コード文字列、2:QRコード、3:JANコード、4:PDF、5:IDパスワード、6:電話番号）のとき、画像を表示 -->
                <div v-if="barcode.CODE_FORMAT === '0' || barcode.CODE_FORMAT === '1' || barcode.CODE_FORMAT === '2' || barcode.CODE_FORMAT === '3' || barcode.CODE_FORMAT === '4' || barcode.CODE_FORMAT === '5' || barcode.CODE_FORMAT === '6'">
                  <img v-if="barcode.CODE_IMG_PATH !== '' && clientType === 0" :class="$style.uploadImg" :src="`${app_img_upload_url}img/upload/${barcode.CODE_IMG_PATH}`" />
                  <img v-else-if="barcode.CODE_IMG_PATH !== '' && clientType === 1" :class="$style.uploadImg" :src="`${app_img_upload_url}img/upload/${barcode.CODE_IMG_PATH}`" />
                  <img v-else-if="barcode.CODE_IMG_PATH !== '' && clientType === 2" :class="$style.uploadImg" :src="`${img_upload_url}img/upload/${barcode.CODE_IMG_PATH}`" />
                  <br/><br/>
                  <div v-if="barcode.CODE_FORMAT === '2' && (clientType === 0 || clientType === 1 || clientType === 2)">
                    <img v-show="expandShrink" :class="$style.qrImg" :src="qrImage" />
                    <div v-show="!expandShrink" >
                      <img :class="$style.qrImg_big" :src="qrImageBig" />
                    </div>
                  </div>
                  <div v-if="barcode.CODE_FORMAT === '3' && barcode.CODE != ''">
                    <svg v-show="expandShrink" id="barcode"></svg>
                    <div v-show="!expandShrink" >
                      <svg id="barcodeBig"></svg>
                    </div>
                  </div>
                </div>
                <!-- コード形式（1:コード文字列）のとき、コード文字列とクリップボードにコピーボタンを表示 -->
                <div v-if="barcode.CODE_FORMAT === '1'">
                  <div :class="$style.code_text">
                    <div v-if="barcode.CODE !== '' && barcode.CODE_FORMAT === '1'" :class="$style.left_text">
                      コード :<span v-if="barcode.CODE.length <= 15"> {{ barcode.CODE }}</span><span v-else> {{ barcode.CODE.substring(0,15) + "..." }}</span>
                    </div>
                    <div v-if="barcode.CODE !== '' && barcode.CODE_FORMAT === '1'" :class="$style.right_text">
                      <button class="clipcopy" type="button" :data-clipboard-text="barcode.CODE">コードをコピー</button>
                      <span class="clipcopy_message" style="color:#e80000;display:none;">コードをコピーしました。</span>
                    </div>
                  </div>
                </div>
                <!-- コード形式（5:IDパスワード）のとき、IDとパスワード、および、コピーボタンを表示 -->
                <!-- HACK: スタイルをHTMLに直接埋め込んでいるため、必要に応じてリファクタリング -->
                <div v-else-if="barcode.CODE_FORMAT === '5'">
                  <div :class="$style.code_text">
                    <table align="center">
                      <tbody style="text-align:left; font-size:16px">
                        <tr>
                          <td style="width:30%;">ID:</td>
                          <td style="width:50%">{{ barcode.CODE_ID }}</td>
                          <td style="width:20%;"><button class="clipcopy_id" type="button" :data-clipboard-text="barcode.CODE_ID" @click="unHiddenCopyMessage('.clipcopy_message_id')">コピー</button></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td colspan="2" class="clipcopy_message_id" style="color:#e80000;display:none;">コピーしました。</td>
                        </tr>
                        <tr>
                          <td>パスワード:</td>
                          <td>{{ barcode.CODE_PW }}</td>
                          <td><button class="clipcopy_pw" type="button" :data-clipboard-text="barcode.CODE_PW" @click="unHiddenCopyMessage('.clipcopy_message_pw')">コピー</button></td>
                        </tr>
                        <tr>
                          <td></td>
                          <td colspan="2" class="clipcopy_message_pw" style="color:#e80000;display:none;">コピーしました。</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- コード形式（6:電話番号）のとき、電話番号を表示 -->
                <div v-if="barcode.CODE_FORMAT === '6'">
                  <div :class="$style.code_text_tel">TEL: <TelPopup :tel="barcode.CODE_TEL" /></div>
                </div>
              </div>
              <div v-if="barcode.CODE_FORMAT === '2' || barcode.CODE_FORMAT === '3'"  :class="$style.expand_box" @click="expandCode">
                <img  v-if="expandShrink" src="@img/拡大する.png" alt="">
                <img  v-if="!expandShrink" src="@img/縮小する.png" alt="">
                <span v-if="expandShrink">　拡大して表示</span>
                <span v-if="!expandShrink">　縮小して表示</span>
              </div>
              <div v-if="barcode.LINK_BUTTON_TITLE !== ''" :class="$style.link_text">
                <span v-if="barcode.LINK_BUTTON_TITLE.length <= 15" :class="[$style.btn, (barcode.LINK_URL !== '') ? $style['on'] : $style['off']]" @click="toUrl(barcode.LINK_URL)">{{barcode.LINK_BUTTON_TITLE}}</span>
                <span v-else :class="[$style.btn, (barcode.LINK_URL !== '') ? $style['on'] : $style['off']]" @click="toUrl(barcode.LINK_URL)">{{ barcode.LINK_BUTTON_TITLE.substring(0,15) + "..." }}</span>
              </div>
              <div v-if="hasBlackListUrl" :class="$style.cap_caution">
                <p>
                  外部のサイトに移動します。
                  <br />※ご注意
                  <br />・リンク先のウェブサイトは、JAFのサイトではありません。
                  <br />・リンク先のサイトの内容については、サイト記載の会社へお問合せください。
                </p>
              </div>
              <div :class="$style.button_text">
                <span :class="[$style.btn, $style.confirm]" @click="cancelHandler">OK</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" module>
// @import '~@assets/css/brand-list.scss';
.qrImg{
  width: 50%;
  margin-bottom:10px;
}
.qrImg_big{
  margin-bottom:10px;
}
.uploadImg{
  max-width: 100%;
}
.expand_box{
  text-align: center;
  color: #008fca;
  margin-bottom: 25px;

  img{
    width: 20px;
  }
}
@media screen and (max-width: 560px) {
  .modal_set {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 89.3%;
    max-height: 80%;
    min-height: 30%;

    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border-radius: 14px;
    overflow: auto;
  }
  .modal_set .cancel_btn {
    position: absolute;
    width: 25px;
    opacity: 1;
    right: 7px;
    top: 7px;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    z-index: 1;
  }
  .modal_set span img {
    width: 25px;
  }
  .modal_contents .modal_inner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 20px 20px;
    overflow: auto;
  }
  .modal_contents .modal_inner .subject {
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    color: #4a4a4a;
    padding: 14px;
    border-bottom: 2px solid #dddddd;
  }
  .modal_contents .modal_inner .content {
    text-align: center;
  }
  .modal_contents .modal_inner .code_text {
    text-align: center;
    font-size: 12px;
  }
  .modal_contents .modal_inner .code_text_tel {
    font-size:18px;
    line-height: 30px;
    font-weight: bold;
    padding: 18px;
  }
  .modal_contents .modal_inner .left_text {
    float:left;
    padding-top:10px;
    width:60%;
  }
  .modal_contents .modal_inner .right_text {
    float:right;
    width:40%;
  }
  .modal_contents .modal_inner .right_text button {
    font-size:12px;
    padding: 5px;
    border:solid 2px #ffb932;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    background-color:#ffb932;
    color:#ffffff;
    font-weight: bold;
    margin: 0px 10px 0px 10px;
  }
  .modal_contents .modal_inner .link_text {
    padding-top:10px;
    text-align: center;
  }
  .modal_contents .modal_inner .link_text span {
    display: inline-block;
  }
  .modal_contents .modal_inner .link_text .btn {
    min-width: 60%;
    padding:0 5px;
    box-sizing: border-box;
    height: 35px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
    // border: 1px solid #070141;
    border-radius: 5px;
    // color: #fff;
    // background: #070141;
  }
  .modal_contents .modal_inner .link_text .btn.on {
    border: 1px solid #070141;
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .link_text .btn.off {
    opacity: 0.3;
    border: 1px solid #070141;
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .button_text {
    padding-top:10px;
    text-align: center;
  }
  .modal_contents .modal_inner .button_text span {
    display: inline-block;
  }
  .modal_contents .modal_inner .button_text .btn {
    box-sizing: border-box;
    width: 60%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #070141;
    border-radius: 5px;
  }
  .modal_contents .modal_inner .button_text .confirm {
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .content p {
    font-size:12px;
    padding: 10px 0;
  }
  .modal_contents .modal_inner .cap_caution {
    font-size:12px;
    color: rgb(232, 0, 0);
    margin: 15px 0;
    text-align: center;
  }
  .modal_contents .modal_inner .cap_caution p {
    display: inline-block;
    text-align: left;
  }
}

@media screen and (min-width: 560px) {
  .modal_set {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40%;
    max-height: 80%;
    min-height: 30%;

    transform: translate(-50%, -50%);

    background-color: #ffffff;
    border-radius: 14px;
    overflow: auto;
  }
  .modal_set .cancel_btn {
    position: absolute;
    width: 33px;
    opacity: 1;
    right: 7px;
    top: 7px;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    z-index: 1;
  }
  .modal_set span img {
    width: 33px;
  }
  .modal_contents .modal_inner {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 20px 20px;
    overflow: auto;
  }
  .modal_contents .modal_inner .subject {
    text-align: center;
    font-size: 22px;
    line-height: 24px;
    font-weight: bold;
    color: #4a4a4a;
    padding: 14px;
    border-bottom: 2px solid #dddddd;
  }
  .modal_contents .modal_inner .content {
    text-align: center;
    font-size: 16px;
  }
  .modal_contents .modal_inner .code_text {
    text-align: center;
    font-size: 16px;
  }
  .modal_contents .modal_inner .code_text_tel {
    font-size:20px;
    line-height: 23px;
    font-weight: bold;
    padding: 10px;
  }
  .modal_contents .modal_inner .left_text {
    float:left;
    padding-top:10px;
    width:60%;
  }
  .modal_contents .modal_inner .right_text {
    float:right;
    width:40%;
  }
  .modal_contents .modal_inner .right_text button {
    font-size:16px;
    padding: 5px;
    border:solid 2px #ffb932;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    background-color:#ffb932;
    color:#ffffff;
    font-weight: bold;
    margin: 0px 10px 0px 10px;
  }
  .modal_contents .modal_inner .link_text {
    padding-top:10px;
    text-align: center;
  }
  .modal_contents .modal_inner .link_text span {
    display: inline-block;
  }
  .modal_contents .modal_inner .link_text .btn {
    min-width: 60%;
    padding: 0 5px;
    box-sizing: border-box;
    height: 35px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
    // border: 1px solid #070141;
    border-radius: 5px;
    // color: #fff;
    // background: #070141;
  }
  .modal_contents .modal_inner .link_text .btn.on {
    border: 1px solid #070141;
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .link_text .btn.off {
    opacity: 0.3;
    border: 1px solid #070141;
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .button_text {
    padding-top:10px;
    text-align: center;
  }
  .modal_contents .modal_inner .button_text span {
    display: inline-block;
  }
  .modal_contents .modal_inner .button_text .btn {
    box-sizing: border-box;
    width: 40%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #070141;
    border-radius: 5px;
  }
  .modal_contents .modal_inner .button_text .confirm {
    color: #fff;
    background: #070141;
  }
  .modal_contents .modal_inner .content p {
    font-size:16px;
    padding: 10px 0;
  }
  .modal_contents .modal_inner .cap_caution {
    font-size:16px;
    color: rgb(232, 0, 0);
    margin: 15px 0;
    text-align: center;
  }
  .modal_contents .modal_inner .cap_caution p {
    display: inline-block;
    text-align: left;
  }
}
@media screen and (min-width: 820px) {
  .qrImg{
    width: 40%;
  }
  .qrImg_big{
    width: 60%;
  }
}
</style>
